module.exports = __webpack_public_path__ + "img/bank.8e02593c.png";